import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {FabricProfileItemList} from '../interface/fabric-profile-item-list';
import {Product} from '../interface/product';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
	providedIn: 'root',
})
export class FilterFabricProfileService {

	public isBrowser: boolean = false;
	public isPreOrderPopupOpen: boolean = false;

	constructor(@Inject(PLATFORM_ID) private _platformId: Object) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	public filterFabricBasedOnMTOProfileConsumption(
		fabricProfiles: FabricProfileItemList[],
		productData: Product
	): FabricProfileItemList[] {

		let copyFabricProfiles = [
			...(productData.fabricProfileEnabled && productData.fabricProfile?.fabricProfileItemList || []),
		];
		let MTOPConsumedFabric: number = 0;
		let MTOPConsumedFabricMOQ: number = 0;

		if (productData.madeToOrderProfileEnabled && productData.madeToOrderProfile) {
			MTOPConsumedFabric =
				productData.madeToOrderProfile.consumedFabric || 0;
		}

		if (productData.madeToOrderProfileEnabled && productData.madeToOrderProfile) {
			MTOPConsumedFabricMOQ =
				productData.madeToOrderProfile.minimumOrderQuantity || 0;
		}

		let flagedFabricQTY: number =
			MTOPConsumedFabric * MTOPConsumedFabricMOQ;

		if (this.isBrowser && localStorage.getItem('isPreOrderPopupOpen')) {
			flagedFabricQTY = 0;
			fabricProfiles = copyFabricProfiles;
		}

		fabricProfiles = fabricProfiles.filter(
			(fabricItem: FabricProfileItemList) => {
				return fabricItem.fabricPreview.totalQuantity >= flagedFabricQTY;
			}
		);

		// Only allow fabrics who’s quantity ≥ MOQ of the made to order profile: TODO: discuss with Amit

		fabricProfiles = fabricProfiles.filter(
			(fabricItem: FabricProfileItemList) => {
				return fabricItem.fabricPreview.totalQuantity >= MTOPConsumedFabricMOQ;
			}
		);

		return fabricProfiles;
	}
}
